import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import anomalyReducer from "../services/anomaly/reducer";
import anomalySaga from "../services/anomaly/saga";
import nodeReducer from "../services/node/reducer";
import nodeSaga from "../services/node/saga";
import authReducer from "../services/auth/reducers";
import authSaga from "../services/auth/sagas";
import applicationReducer from "../services/applications/reducer";
import applicationSaga from "../services/applications/saga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    anomaly: anomalyReducer,
    node: nodeReducer,
    auth: authReducer,
    applications: applicationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
  devTools: false,
});

sagaMiddleware.run(anomalySaga);
sagaMiddleware.run(nodeSaga);
sagaMiddleware.run(authSaga);
sagaMiddleware.run(applicationSaga);

export default store; 